import React from 'react'
import PropTypes from 'prop-types'
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import MuiToggleButton from '@mui/material/ToggleButton'

export function ToggleButtonGroup({
  value,
  trueText,
  falseText,
  onClick,
  className
}) {
  const buttonSx = {
    backgroundColor: '#ffffff',
    color: '#564C47',
    fontFamily: "'JohnsonText', Arial",
    fontSize: '12px',
    height: '32px',
    textTransform: 'none',
    fontWeight: '600',
    borderRadius: '50px',
    '&.Mui-disabled': {
      color: '#ffffff',
      backgroundColor: '#564C47'
    }
  }

  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        width: '172px',
        borderRadius: '50px',
        overflow: 'hidden',
      }}
    >
      <MuiToggleButtonGroup value={value} exclusive>
        <div>
          <MuiToggleButton
            value="true"
            onClick={() => onClick(true)}
            sx={buttonSx}
            disabled={value}
          >
            {trueText}
          </MuiToggleButton>
        </div>

        <div>
          <MuiToggleButton
            value="false"
            onClick={() => onClick(false)}
            sx={buttonSx}
            disabled={!value}
          >
            {falseText}
          </MuiToggleButton>
        </div>
      </MuiToggleButtonGroup>
    </div>
  )
}

ToggleButtonGroup.propTypes = {
  trueText: PropTypes.string.isRequired,
  falseText: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
}

ToggleButtonGroup.defaultProps = {
  className: '',
  onClick: () => {}
}
